import { render, staticRenderFns } from "./cgBiddingNotice.vue?vue&type=template&id=4655b6ae&scoped=true"
import script from "./cgBiddingNotice.vue?vue&type=script&lang=js"
export * from "./cgBiddingNotice.vue?vue&type=script&lang=js"
import style0 from "./cgBiddingNotice.vue?vue&type=style&index=0&id=4655b6ae&prod&lang=scss&scoped=true"
import style1 from "./cgBiddingNotice.vue?vue&type=style&index=1&id=4655b6ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4655b6ae",
  null
  
)

export default component.exports